<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center" v-if="!showInviteForm">
        <h3 class="mb-0 mr-1">Convites</h3>
        <b-button variant="primary" @click="$router.push({ name: 'admin.investor.invites.new' })">
          <span class="mb-0 text-dark font-weight-bolder"> Criar convite </span>
        </b-button>
      </div>

      <invite-form v-else @closeForm="closeInviteForm"></invite-form>

      <convite from="adminInvestidor"></convite>

    </b-card>
  </div>

</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import InviteForm from '@/views/admin/investor/components/InviteForm.vue'
import Convite from '@views/admin/assignor/components/Convite.vue';

export default {
  name: 'AdminInvestorIndexPage',
  components: {
    BCard,
    BButton,
    InviteForm,
    Convite
  },
  data() {
    return {
      currentPage: 1,
      activePagination: false,
      perPage: 10,
      totalRows: 0,
      perPageOptions: [10, 25, 50],
      invites: [],
      search: 'ddsd',
      showInviteForm: false,
    }
  },
  methods: {
    closeInviteForm() {
      this.showInviteForm = false
      this.fetchInvites()
    },
  },
}
</script>
</style>
